/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Forgot_LinkInputs */

const cs_auth_forgot_link = /** @type {(inputs: Auth_Forgot_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zapomenuté heslo?`)
};

const en_auth_forgot_link = /** @type {(inputs: Auth_Forgot_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forgot password?`)
};

/**
* | output |
* | --- |
* | "Forgot password?" |
*
* @param {Auth_Forgot_LinkInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const auth_forgot_link = /** @type {((inputs?: Auth_Forgot_LinkInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Forgot_LinkInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_auth_forgot_link(inputs)
	return cs_auth_forgot_link(inputs)
});